import API from '@services/API';
import KeycloakService from '@services/keycloakService';

export const getAnnouncementsWithAuthHeader = async (
    url: string,
    user?: { activeModuleName?: string; roles?: Record<string, string> },
) => {
    const authHeader = await KeycloakService.getAuthHeader();

    let userRoleHeaders = {};
    if (user) {
        const { activeModuleName, roles } = user;
        const encCurrentRole = roles?.[activeModuleName?.toUpperCase() ?? ''] || '';
        userRoleHeaders = {
            currentUserRole: activeModuleName,
            encCurrentRole,
        };
    }

    return API.getData(url, () => {}, {}, false, null, false, { ...authHeader, ...userRoleHeaders });
};
